import Api from '../../plugins/Api';
import moment from "moment";
import uid from "uid";
function getDefault(data, params = null) {
    return new Promise((resolve, reject) => {
        let config = JSON.parse(localStorage.getItem("config"))
        Api.http.all([
            Api.http.get(`https://${config.servidor}:8004${data}`, { params: params }).then(res => {
                if (res.data) {
                    resolve(res.data);
                }
            }).catch(err => {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET DEFAULT] ` + err)
                reject(err);
            })
        ])
    })
}
function getMeusAtendimentos(state, that) {
    try {
        //#region Parametros requisicao
        let config = JSON.parse(localStorage.getItem("config"))
        let user = JSON.parse(localStorage.getItem("user"))
        var order = [];
        var obj = {
            campo: 'id',
            ordem: 'DESC'
        };
        let agentes = [];
        agentes.push(user.fullname);
        order.push(obj);
        let status = [];
        status.push(`Entrou`);
        let param = {
            max: -1,
            page: 1,
            FullMsg: false,
            order: JSON.stringify(order),
            agentes: JSON.stringify(agentes),
            status: JSON.stringify(status)
        }
        //#endregion
        if (user) {
            Api.http.get(`https://${config.servidor}:8004/api/v2/chats`, { params: param }).then(res => {
                state.loading = false;
                if (res.data.dados && res.data.dados.length > 0) {
                    let atendimentos = res.data.dados
                    that._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET MEUS ATENDIMENTOS DADOS] ` + JSON.stringify(atendimentos))

                    //vamos percorrer para ver se tem algum que nao esta mais com o agente
                    for (let atendimento of state.atendimentos) {
                        let remover = atendimentos.find(a => atendimento.id == a.id);
                        if (!remover) {
                            console.log(`achamos `, atendimento);
                            console.log(`atendimentos no client`, state.atendimentos);
                            console.log(`atendimentos req`, atendimentos);
                            let index = state.atendimentos.findIndex(a => a.id === atendimento.id);
                            if (index !== -1) {
                                state.atendimentos.splice(index, 1);
                                if (state.atendimento && atendimento.id === state.atendimento.id) state.atendimento = null;
                                console.log(`removemos`, atendimento.id);
                            }
                        }
                    }
                    //Vamos percorrer para ver se tem algum novo
                    for (let atendimento of state.atendimentos) {
                        atendimentos = atendimentos.filter(a => atendimento.id !== a.id);
                    }
                    //caso tenha um novo bora adicionar
                    if (atendimentos.length > 0) {
                        for (let atendimento of atendimentos) {
                            atendimento.messages = [];
                            atendimento.count = 1;
                            state.atendimentos.unshift(atendimento);
                            //if (config.notificacao) ipcRenderer.send("new-msg", { message: { texto: `#${atendimento.id}` }, tocar: config.somnotificacao });

                        }
                    }
                } else if (res.data.dados) {
                    //caso tenha retornado ok e nao tenha dados vamos zerar o array
                    state.atendimento = null;
                    state.atendimentos = [];
                }

            }).catch(err => {
                state.loading = false;
                console.error(err);
            })
        }
    } catch (error) {
        that._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET MEUS ATENDIMENTOS ERROR] ` + error)

        console.error(error);
    }
}
export default {
    namespaced: true,
    state: {
        atendimentos: [],
        templates: [],
        atendimento: null,
        atendimentoH: [],
        agentes: null,
        ramais: [],
        filas: null,
        agente: {},
        conectado: false,
        error: false,
        errorMsg: null,
        loading: false,
        cliente: null,
        clientes: null,
        atendimentosSearch: null,
        atendimentosHistorico: null,
        atendimentosLoading: false,
        transferenciaModal: false,
        uploadStatus: 0,
        modalConfig: false,
        drawer: false,
        ultimoDiscado: null,
        pausas: [],
        sendSuccessId: null,
        filaStatus: [],
        enviarMensagem: true
    },
    mutations: {
        XC_getTemplatesZenvia(state, data) {
            let templates = JSON.parse(data.dados);
            state.templates = [];
            templates.map(t => state.templates.push(t));
            // state.templates = templates;
            console.log(`templates`, templates);
        },
        XC_FilasStatus(state, data) {
            if (state.filaStatus.length > 0) {
                for (let fila of data.filas) {
                    let index = state.filaStatus.findIndex(f => f.nome === fila.nome);
                    if (index !== -1) {
                        state.filaStatus.splice(index, 1, fila);
                    } else {
                        state.filaStatus.push(fila);
                    }
                }
            } else {
                state.filaStatus = data.filas;
            }

        },
        XC_connect(state) {
            state.loading = false;
            state.conectado = true;
            let aux = {
                action: 'QueueStatus'
            }
            this._vm.$Xcontact.sendMessage(aux);
        },

        XC_error(state, data) {
            state.loading = true;
            state.conectado = false;
        },
        XC_errorMsg(state, data) {
            state.error = true;
            state.errorMsg = data.msg;
            setTimeout(() => {
                state.error = false;
                state.errorMsg = ''
            }, 5000);
        },

        XC_disconnectConfig(state) {
            state.loading = true;
            state.conectado = false;
            state.filas = null;
            state.atendimentos = [];
            state.agentes = null;
            state.atendimentos = []
            state.atendimento = null
            state.agentes = null
            state.filas = null
            state.agente = {}
            state.conectado = false
            state.loading = false
            state.cliente = null
            state.clientes = null
            state.uploadStatus = 0
        },
        xc_disconnect(state) {
            state.loading = true;
            state.conectado = false;
        },
        XC_connect_error(state) {
            state.loading = true;
            state.conectado = false;
        },
        XC_uploadStatus(state, data) {
            state.uploadStatus = data;
        },
        XC_TransfereAtendimento(state) {
            getMeusAtendimentos(state, this);
        },

        XC_getMeusAtendimentos(state) {
            console.log(`GET MEUS ATENDIMENTOS`);
            getMeusAtendimentos(state, this);
        },
        async XC_getMeusAtendimentosOLD(state) {
            try {
                let config = JSON.parse(localStorage.getItem("config"))
                let user = JSON.parse(localStorage.getItem("user"))
                var order = [];
                var obj = {
                    campo: 'id',
                    ordem: 'DESC'
                };
                let agentes = [];
                agentes.push(user.fullname);
                order.push(obj);
                let status = [];
                status.push(`Entrou`);
                let param = {
                    max: -1,
                    page: 1,
                    FullMsg: false,
                    order: JSON.stringify(order),
                    agentes: JSON.stringify(agentes),
                    status: JSON.stringify(status)
                }
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v2/chats`, { params: param }).then(res => {
                        if (res.data.dados) {
                            // commit('addAtendimentoSearch', atendimentos);
                            for (let a of res.data.dados) {
                                a.messages = [];
                                let atendimento = state.atendimentos.find(at => at.id === a.id);
                                if (atendimento) a.count = atendimento.count;
                            }
                            let atendimentos = [];
                            //Bora ver ser tem algum atendimento novo
                            for (let atendimento of state.atendimentos) {
                                atendimentos.push(res.data.dados.find(at => atendimento.id != at.id));
                            }
                            if (atendimentos.length > 0) {
                                //Tem atendimento novo bora notificar
                                for (let atendimento of atendimentos) {
                                    //  if (config.notificacao) ipcRenderer.send("new-msg", { message: { texto: `#${atendimento.id}` }, tocar: config.somnotificacao });

                                }
                            }
                            state.atendimentos = res.data.dados
                        }
                    }).catch(err => {
                        if (err.response) {
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }


                    })
                ])
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', error)
                console.log(error);
            }


        },
        async XC_SendSuccess(state, dados) {
            console.log(`SENDSUCCESS`, dados);
            this.enviarMensagem = true;
            let atendimento = state.atendimentos.find(a => a.id === dados.protocolo);
            if (atendimento) {
                if (dados.errorMsg) {
                    state.error = true;
                    state.errorMsg = dados.errorMsg;
                }
            }
            setTimeout(async () => {
                if (atendimento) {
                    state.sendSuccessId = uid();
                    let config = JSON.parse(localStorage.getItem(`config`));

                    Api.http.all([
                        Api.http.get(`https://${config.servidor}:8004/api/v2/chat/${atendimento.id}/mensagens?max=-1&page=1`).then(async res => {
                            if (res.data) {
                                for (let msg of res.data.dados) {
                                    if (!msg.queueAnexos)
                                        msg.queueAnexos = msg.mensagemAnexos;
                                    msg.dadosAdicionais = msg.dados_adicionais;

                                }
                                atendimento.messages = res.data.dados;
                            }
                        }).catch(err => {
                            console.error(err);
                        })
                    ])
                    //atendimento.messages.map(m => m.status = `seen`)
                }

            }, 1000);
        },

        // XC_Tocando(state, message) {
        //     let atendimento = message;
        //     if (state.atendimentos.length > 0) {
        //         let index = state.atendimentos.findIndex(a => message.id === a.id);
        //         if (index !== -1) {
        //             state.atendimentos.splice(index, 1, message)
        //             state.atendimento = message;
        //             state.atendimento.lastMsg = atendimento.messages[atendimento.messages.lengh - 1];

        //         } else {
        //             state.atendimentos.unshift(message);
        //             state.atendimento = message;
        //             state.atendimento.lastMsg = atendimento.messages[atendimento.messages.lengh - 1];
        //         }
        //         return;
        //     }
        //     state.atendimentos.push(atendimento);
        //     state.atendimento = message;
        //     state.atendimento.lastMsg = atendimento.messages[atendimento.messages.lengh - 1];
        // },
        // XC_Atendeu(state, message) {
        //     let atendimento = message;
        //     if (state.atendimentos.length > 0) {
        //         let index = state.atendimentos.findIndex(a => message.id === a.id);
        //         if (index !== -1) {
        //             state.atendimentos.splice(index, 1, message)
        //             state.atendimento = message;
        //             state.atendimento.lastMsg = atendimento.messages[atendimento.messages.lengh - 1];
        //         }
        //     }
        // },
        // XC_Hangup(state, message) {
        //     if (state.atendimentos.length > 0) {
        //         if (message.id) {
        //             let index = state.atendimentos.findIndex(a => message.id === a.id);

        //             if (index !== -1) {
        //                 if (state.atendimento && state.atendimentos[index].id === state.atendimento.id) state.atendimento = null;
        //                 state.atendimentos.splice(index, 1);
        //             }
        //             return;
        //         }
        //         let index = state.atendimentos.findIndex(a => message.linkedid === a.linkedid);
        //         if (index !== -1) {
        //             if (state.atendimento && state.atendimentos[index].linkedid === state.atendimento.linkedid) state.atendimento = null;
        //             state.atendimentos.splice(index, 1);
        //         }
        //     }
        // },
        XC_RemoveAtendimento(state, message) {
            if (state.atendimentos.length > 0) {
                let index = state.atendimentos.findIndex(a => message.id === a.id);
                if (index !== -1) {
                    if (state.atendimento && state.atendimentos[index].id === state.atendimento.id) state.atendimento = null;
                    state.atendimentos.splice(index, 1);
                }
            }
        },
        async XC_newMessage(state, dados) {
            try {
                dados.message.id = dados.message.messageID;
                dados.atendimento.messages = []
                dados.atendimento.messages.push(dados.message);
                let config = JSON.parse(localStorage.getItem(`config`));
                let msgAux = { texto: dados.message.texto, nome: dados.atendimento.fromName ? dados.atendimento.fromName : dados.atendimento.fromID.split(`@`)[0] };
                if (config.notificacao)
                    //    ipcRenderer.send("new-msg", { message: msgAux, tocar: config.somnotificacao });

                    if (state.atendimentos.length > 0) {
                        let index = state.atendimentos.findIndex(a => dados.message.idAtendimento === a.id);
                        //ATENDIMENTO JA ESTA NO CLIENT
                        if (index !== -1) {
                            let atendimento = state.atendimentos[index];
                            let retorno = await getDefault(
                                `/api/v2/chat/${atendimento.id}/mensagens?max=-1&page=1`
                            );
                            if (retorno && retorno.dados) {
                                for (let msg of retorno.dados) {
                                    if (!msg.queueAnexos)
                                        msg.queueAnexos = msg.mensagemAnexos;

                                    if (!msg.dadosAdicionais) msg.dadosAdicionais = msg.dados_adicionais;


                                }
                                atendimento.messages = retorno.dados;
                                atendimento.messages.sort(function (a, b) {
                                    return a.id - b.id;
                                });
                                atendimento.lastMsg = atendimento.messages[atendimento.messages.length - 1];
                            }
                            //VERIFICANDO SE TEM ALGUM ATENDIMENTO SELECINADO
                            if (state.atendimento) {
                                //SE O ATENDIMENTO NAO FOR O SELECIONADO BORA CONTAR 
                                if (atendimento.id !== state.atendimento.id) {
                                    atendimento.count++;
                                } else {
                                    atendimento.qtd_msg++;
                                }

                            } else {
                                //NAO TEM ATENDIMENTO ENTAO POSSO CONTAR
                                atendimento.count++;

                            }
                            state.atendimentos.splice(index, 1);
                            // atendimento.qtd_msg++;
                            if (!state.atendimentos.find(a => a.id === dados.atendimento.id)) {
                                state.atendimentos.unshift(atendimento);
                            }

                            localStorage.setItem(`atendimentos`, JSON.stringify(state.atendimentos));
                            return;
                        } else {
                            //NAO TINHA O ATENDIMENTO NO CLIENT VAMOS CRIAR
                            let retorno = await getDefault(
                                `/api/v2/chat/${dados.atendimento.id}/mensagens?max=-1&page=1`
                            );
                            if (retorno && retorno.dados) {
                                for (let msg of retorno.dados) {
                                    if (!msg.queueAnexos)
                                        msg.queueAnexos = msg.mensagemAnexos;

                                    if (!msg.dadosAdicionais) msg.dadosAdicionais = msg.dados_adicionais;

                                }
                                dados.atendimento.messages = retorno.dados;
                                dados.atendimento.messages.sort(function (a, b) {
                                    return a.id - b.id;
                                });
                                if (dados.atendimento.messages.length > 0) {
                                    dados.atendimento.lastMsg = dados.atendimento.messages[dados.atendimento.messages.length - 1];
                                }
                            }
                            dados.atendimento.count = 1;
                            if (!state.atendimentos.find(a => a.id === dados.atendimento.id)) {
                                state.atendimentos.unshift(dados.atendimento);
                            }

                            localStorage.setItem(`atendimentos`, JSON.stringify(state.atendimentos));
                            return
                        }

                    }
                //NAO TEM ATENDIMENTOS BORA CRIAR
                delete dados.message;
                let retorno = await getDefault(
                    `/api/v2/chat/${dados.atendimento.id}/mensagens?max=-1&page=1`
                );
                if (retorno && retorno.dados) {
                    for (let msg of retorno.dados) {
                        if (!msg.queueAnexos)
                            msg.queueAnexos = msg.mensagemAnexos;
                        if (!msg.dadosAdicionais) msg.dadosAdicionais = msg.dados_adicionais;

                    }
                    dados.atendimento.messages = retorno.dados;
                    dados.atendimento.messages.sort(function (a, b) {
                        return a.id - b.id;
                    });
                    if (dados.atendimento.messages.length > 0) {
                        dados.atendimento.lastMsg = dados.atendimento.messages[dados.atendimento.messages.length - 1];
                    }
                }
                dados.atendimento.count = 1;
                state.atendimentos.unshift(dados.atendimento);
                localStorage.setItem(`atendimentos`, JSON.stringify(state.atendimentos));
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [NEW MESSAGE ERROR] ` + error)

                console.error(error);
            }


        },
        updateAtendimento(state, dados) {
            let index = state.atendimentos.findIndex(a => a.id === dados.id);
            if (index !== -1) {
                let atendimento = dados;
                state.atendimentos.splice(index, 1, atendimento);
            }
        },
        addAtendimento(state, dados) {
            if (dados.messages && dados.messages.length > 0) {
                dados.messages.map(m => m.status = 'seen');
                dados.lastMsg = dados.messages[dados.messages.length - 1];
            }
            let index = state.atendimentos.findIndex(a => a.id === dados.id);
            if (index === -1) {
                dados.count = dados.count ? dados.count : 0;
                state.atendimentos.unshift(dados);
            }
        },

        addAtendimentos(state, dados) {
            state.atendimentos = dados;
        },

        addAtendimentoSearch(state, dados) {
            state.atendimentosSearch = dados;

        },

        addAtendimentoHistorico(state, dados) {
            state.atendimentosHistorico = dados;

        },
        addAgentes(state, dados) {
            state.agentes = dados;
        },
        addRamais(state, dados) {
            state.ramais = dados;
        },
        addPausas(state, dados) {
            state.pausas = dados;
        },
        addFilas(state, dados) {
            state.filas = dados;
        },
        setUltimoDiscado(state, dados) {
            state.ultimoDiscado = dados;
        },
        removerAtendimento(state, dados) {
            let index = state.atendimentos.findIndex(a => a.id === dados.id);
            if (index !== -1) {
                if (state.atendimento && state.atendimentos[index].id === state.atendimento.id) {
                    state.atendimento = null;
                }
                state.atendimentos.splice(index, 1);
            }
        },
        setModalConfig(state, data) {
            state.modalConfig = data;
        },
        setDrawer(state, data) {
            state.drawer = data;
        },
        removeAtendimentos(state) {
            state.atendimentosSearch = [];
        },
        removeAtendimentosHistorico(state) {
            state.atendimentosHistorico = [];
        },
        selectAtendimento(state, dados) {
            state.atendimento = dados;
            if (!dados) return;
            let atendimento = state.atendimentos.find(a => a.id === dados.id);
            if (atendimento) {
                atendimento.count = 0;
                //state.atendimento = atendimento;
            }
            let atendimentoSearch = state.atendimentosSearch.find(a => a.id === dados.id);
            if (atendimentoSearch) {
                atendimentoSearch.count = 0;
                //state.atendimento = atendimentoSearch;
            }
            localStorage.setItem(`atendimentos`, JSON.stringify(state.atendimentos));

        },
        clearAtendimento(state) {
            state.atendimento = null;
        },
        selectAtendimentoH(state, dados) {
            state.atendimentoH = dados;
        },
        selectCliente(state, data) {
            state.cliente = data;
        },
        setEnviarMensagem(state, data) {
            this.enviarMensagem = data;
        },
        addMessage(state, data) {
            state.atendimento.messages.push(data);
            let index = state.atendimentos.findIndex(a => a.id === state.atendimento.id);
            if (index != -1) {
                if (state.atendimento.messages.length > 0) {
                    state.atendimento.lastMsg = state.atendimento.messages[state.atendimento.messages.length - 1];
                }
                state.atendimentos.splice(index, 1);
                state.atendimentos.unshift(state.atendimento);
                state.atendimento.qtd_msg++;
                localStorage.setItem(`atendimentos`, JSON.stringify(state.atendimentos));
                this.enviarMensagem = false;
            }
        },
        async addMessages(state, data) {
            state.atendimento.messages = [];
            //state.atendimento.messages = data;           
            for (let msg of data) {
                if (!msg.queueAnexos)
                    msg.queueAnexos = msg.mensagemAnexos;
                if (!msg.dadosAdicionais) msg.dadosAdicionais = msg.dados_adicionais;
            }
            state.atendimento.messages = data;
            state.atendimento.messages.sort(function (a, b) {
                return a.id - b.id;
            });
        },
        async addMessagesH(state, data) {
            state.atendimentoH.messages = [];
            //state.atendimento.messages = data;
            for (let msg of data) {
                if (!msg.queueAnexos)
                    msg.queueAnexos = msg.mensagemAnexos;
                if (!msg.dadosAdicionais) msg.dadosAdicionais = msg.dados_adicionais;
            }
            state.atendimentoH.messages = data;
            state.atendimentoH.messages.sort(function (a, b) {
                return a.id - b.id;
            });

        },
        setLoading(state, data) {
            state.loading = data;
        },
        setLoadingAtendimentos(state, data) {
            state.atendimentosLoading = data;
        },
        setError(state, data) {
            state.error = data.error;
            if (data.error) state.errorMsg = data.msg;
        },

        setClientes(state, dados) {
            state.clientes = dados;

        },
        setCliente(state, dados) {
            if (!state.clientes) state.clientes = [];
            if (state.clientes.findIndex(c => c.id === dados.id) === -1)
                state.clientes.push(dados);

        },
        setTransferenciaModal(state, dados) {
            state.transferenciaModal = dados;
        }

    },
    actions: {
        getAtendimentos({ commit }, dados) {
            commit('setLoading', true);

            try {
                let config = JSON.parse(localStorage.getItem("config"))
                var order = [];
                var obj = {
                    campo: 'id',
                    ordem: 'DESC'
                };
                let agentes = [];
                agentes.push(dados.fullname);
                order.push(obj);
                let status = [];
                status.push(`Entrou`);
                let param = {
                    max: -1,
                    page: 1,
                    FullMsg: false,
                    order: JSON.stringify(order),
                    agentes: JSON.stringify(agentes),
                    status: JSON.stringify(status)
                }
                commit('setLoading', true);
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v2/chats`, { params: param }).then(res => {
                        if (res.data.dados) {
                            commit(`removeAtendimentos`);
                            // commit('addAtendimentoSearch', atendimentos);
                            let atendimentos = localStorage.getItem(`atendimentos`);
                            atendimentos = JSON.parse(atendimentos)
                            if (!atendimentos) atendimentos = [];
                            let aux = res.data.dados.sort(function (a, b) {
                                if (a.data_hora_last_msg || b.data_hora_last_msg) {
                                    return new Date(b.data_hora_last_msg) - new Date(a.data_hora_last_msg);
                                } else {
                                    return a.id - b.id
                                }
                            });
                            for (let a of aux) {
                                a.messages = [];
                                let atendimento = atendimentos.find(at => at.id === a.id);
                                if (atendimento) {
                                    a.count = 0;
                                    if (a.qtd_msg) {
                                        if (a.qtd_msg > atendimento.qtd_msg) {
                                            let contador = a.qtd_msg - atendimento.qtd_msg;
                                            a.count += contador;
                                        }
                                    }
                                }
                                //a.queueTypeID = a.queuetype;                            


                            }
                            commit('addAtendimentos', aux);
                            commit('setLoading', false);
                        }
                    }).catch(err => {
                        if (err.response) {
                            commit('setLoading', false);
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }


                    })
                ])
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET ATENDIMENTOS ERROR] ` + error)
                console.log(error);
            }

            // return new Promise((resolve, reject) => {
            //     let config = JSON.parse(localStorage.getItem("config"))
            //     Api.http.get(`https://${config.servidor}:8004/api/v2/chats/${dados.fullname}`).then(res => {
            //         commit('setLoading', false);
            //         res.data = res.data.sort(function (a, b) {
            //             return b.id - a.id;
            //         })
            //         let atendimentos = localStorage.getItem(`atendimentos`);
            //         atendimentos = JSON.parse(atendimentos)
            //         for (let a of res.data) {
            //             if (atendimentos) {
            //                 let atendimento = atendimentos.find(at => at.id === a.id);
            //                 if (atendimento) {
            //                     a.count = atendimento.count;
            //                 }
            //             }
            //             commit('addAtendimento', a);
            //         }
            //         resolve();
            //     }).catch(err => {
            //         commit('setLoading', false);
            //         reject(err);
            //         // commit('setError', { error: true, msg: err.response.data.message });
            //     })
            // })

        },
        getMeusAtendimentos({ commit }) {
            commit('XC_getMeusAtendimentos')
        },
        updateAtendimento({ commit }, dados) {
            commit(`updateAtendimento`, dados);
        },
        updateCliente({ commit }, dados) {
            commit('setLoading', true);
            let config = JSON.parse(localStorage.getItem("config"))
            let { id, clienteGrupo, ...data } = dados;
            if (data.CamposAdicionais.length > 0) {
                data.CamposAdicionais = data.CamposAdicionais.map(a => { delete a.id; delete a.clienteID; return a; });
            }
            if (data.NumerosAdicionais.length > 0) {
                data.NumerosAdicionais = data.NumerosAdicionais.map(a => { delete a.id; delete a.clienteID; return a; });
            }
            delete data.facebookID;
            Api.http.put(`https://${config.servidor}:8004/api/v2/clientes/${dados.id}`, data).then(res => {
                commit('setLoading', false);
                if (res.data) {
                    commit('updateCliente', dados);
                }
            }).catch(err => {
                console.log(err);
                commit('setLoading', false);
                // commit('setError', { error: true, msg: err.response.data.message });
            })
        },
        addAtendimento({ commit }, index) {
            commit('addAtendimento', index);
        },
        addMessages({ commit }, data) {
            commit('addMessages', data);
        },
        addMessagesH({ commit }, data) {
            commit('addMessagesH', data);
        },
        selectAtendimento({ commit }, dados) {
            commit('selectAtendimento', dados);
        },
        clearAtendimento({ commit }) {
            commit('clearAtendimento');

        },
        selectAtendimentoH({ commit }, dados) {
            return new Promise((resolve) => {
                commit('selectAtendimentoH', dados);
                resolve();
            })

        },
        selectCliente({ commit }, dados) {
            commit('selectCliente', dados);
        },
        addAgentes({ commit }, dados) {
            commit('addAgentes', dados);
        },
        addRamais({ commit }, dados) {
            commit('addRamais', dados);
        },
        setTransferenciaModal({ commit }, dados) {
            commit('setTransferenciaModal', dados);
        },
        addFilas({ commit }, dados) {
            commit('addFilas', dados);
        },
        addPausas({ commit }, dados) {
            commit(`addPausas`, dados);
        },
        encerrarAtendimento({ commit }, dados) {
            commit('removerAtendimento', dados);
            const aux = {
                dataFim: moment().format(),
                protocolo: dados.id,
                queue: dados.queue,
                action: 'EncerrarAtendimento'
            }
            this._vm.$Xcontact.sendMessage(aux);
        },
        async sendMessage({ commit }, dados) {

            let retorno = await getDefault(
                `/api/v2/chats`, { id: dados.idAtendimento }
            );
            if (!retorno || retorno.dados.length === 0) return;
            let atendimento = retorno.dados[0];
            let user = JSON.parse(localStorage.getItem('user'));
            if (atendimento.status !== 'Entrou') {
                commit('setError', { error: true, msg: 'Atendimento encerrado!' });
                return commit('XC_getMeusAtendimentos');
            }
            if (atendimento.ultimoAgente !== user.fullname) {
                commit('setError', { error: true, msg: 'Atendimento esta sendo atendido por outro agente!' });
                return commit('XC_getMeusAtendimentos');

            }
            commit('addMessage', { ...dados });

            // const toID = dados.fromID.indexOf('@') > 0 ? dados.fromID.substring(0, dados.fromID.indexOf("@")) : dados.fromID;
            // dados.toID = toID;
            dados.protocolo = dados.idAtendimento;
            // dados.resposta = dados.texto.replace(/(<([^>]+)>)/ig, "");
            dados.message = dados.texto;
            dados.repliedIdMsg = !dados.repliedMsg ? null : dados.repliedMsg.mailMessageID;
            dados.action = !dados.repliedMsg ? "ClientChatMessage" : "replyMessage";
            this._vm.$Xcontact.sendMessage(dados);
        },
        deleteMsg({ commit }, dados) {
            console.log(commit);
            let aux = {};
            aux.protocolo = dados.protocolo;
            aux.msg = dados.msg;
            aux.action = `deleteMessage`;
            this._vm.$Xcontact.io.emit(`message`, JSON.stringify(aux));
        },
        retryMsg({ commit }, dados) {
            console.log(commit);
            let aux = {};
            aux.protocolo = dados.protocolo;
            aux.msg = dados.msg;
            aux.action = `retryMessage`;
            this._vm.$Xcontact.io.emit(`message`, JSON.stringify(aux));
        },
        async sendMessageFile({ commit }, dados) {
            console.log(dados);
            commit('addMessage', dados.dados);
            let retorno = await getDefault(
                `/api/v2/chats`, { id: dados.dados.idAtendimento }
            );
            if (!retorno || retorno.dados.length === 0) return;
            let atendimento = retorno.dados[0];
            let user = JSON.parse(localStorage.getItem('user'));
            if (atendimento.status !== 'Entrou') {
                commit('setError', { error: true, msg: 'Atendimento esta sendo atendido por outro agente!' });
                return commit('XC_getMeusAtendimentos');
            }
            if (atendimento.ultimoAgente !== user.fullname) {
                commit('setError', { error: true, msg: 'Atendimento esta sendo atendido por outro agente!' });
                return commit('XC_getMeusAtendimentos');

            }
            // const toID = dados.fromID.indexOf('@') > 0 ? dados.fromID.substring(0, dados.fromID.indexOf("@")) : dados.fromID;
            // dados.toID = toID;
            dados.dados.protocolo = dados.dados.idAtendimento;
            if (dados.dados.texto) dados.dados.resposta = dados.dados.texto.replace(/<\/?p[^>]*>/g, "");

            dados.dados.message = dados.dados.texto;
            dados.dados.Msg = dados.dados.texto;
            dados.dados.action = !dados.dados.repliedMsg ? "ClientChatMessage" : "replyMessage";
            if (dados.dados.queueTypeID === 4) {
                this._vm.$Xcontact.sendMessageFileEmail(dados);
            } else {
                this._vm.$Xcontact.sendMessageFile(dados);
            }

        },
        newCall({ commit }, dados) {
            // commit('setUltimoDiscado', dados.numero)
            // dados.fila = dados.queue

            this._vm.$Xcontact.sendMessage(dados);
            console.log(`enviamos`, dados);
        },
        setUltimoDiscado({ commit }, dados) {
            commit('setUltimoDiscado', dados);
        },

        hangup({ commit }, dados) {
            console.log(commit);
            var canal = dados.ramal;
            canal = dados.ramal.split('/');
            var d = {
                canal: canal[0],
                destino: dados.ramal,
                action: 'Desliga'
            }
            this._vm.$Xcontact.sendMessage(d);
        },
        newEmail({ commit }, data) {
            let atendimento = {};
            atendimento.fromID = data.email;
            atendimento.remetente = data.email;
            atendimento.image = '';
            atendimento.queue = data.queue;
            atendimento.name = data.nome;
            atendimento.status = 'Ativo';
            atendimento.ativo = 1;
            atendimento.agente = data.agente;
            atendimento.ramal = data.ramal;
            atendimento.assunto = data.assunto;
            atendimento.queueTypeID = 4;
            atendimento.action = 'addAtendimento';
            atendimento.email = data.email
            commit('setLoading', true);
            this._vm.$Xcontact.sendMessage(atendimento);

        },
        newWhatsApp({ commit }, data) {
            let atendimento = {};
            atendimento.fromID = data.numero + '@c.us';
            atendimento.remetente = data.numero;
            atendimento.image = '';
            atendimento.queue = data.queue;
            atendimento.queueFrom = data.instancia;
            atendimento.name = data.nome;
            atendimento.status = 'Ativo';
            atendimento.ativo = 1;
            atendimento.agente = data.agente;
            atendimento.ramal = data.ramal;
            atendimento.queueTypeID = 3;
            atendimento.action = 'addAtendimento';
            commit('setLoading', true);
            this._vm.$Xcontact.sendMessage(atendimento);

        },
        disconnect() {
            this._vm.$Xcontact.disconnect();
        },
        transfereAtendimento({ commit }, data) {
            commit('setLoading', true);
            let user = JSON.parse(localStorage.getItem(`user`));
            if (data.tipo === 'agente') {
                const dados = {
                    socketID: this._vm.$Xcontact.io.id,
                    action: 'TransferenciaAtendimento',
                    protocolo: data.atendimento.id,
                    location: data.agente.ramal,
                    ramal: user.ramal,
                    nome: data.agente.nome,
                    queue: data.fila,
                    queueFrom: data.atendimento.queueFrom ? data.atendimento.queueFrom : data.atendimento.queue,

                }
                this._vm.$Xcontact.sendMessage(dados);

            } else {
                const dados = {
                    socketID: this._vm.$Xcontact.io.id,
                    action: 'TransfereAtendimentoParaFila',
                    protocolo: data.atendimento.id,
                    queue: data.fila,
                    queueFrom: data.atendimento.queueFrom ? data.atendimento.queueFrom : data.atendimento.queue,
                    ramal: user.ramal
                }
                this._vm.$Xcontact.sendMessage(dados);
                commit('setLoading', false);
            }
            commit(`removerAtendimento`, data.atendimento)

        },
        getTemplates({ commit }, data) {
            data.action = 'getTemplates';
            this._vm.$Xcontact.sendMessage(data);
        },
        sendTemplateMsgZenvia({ commit }, data) {
            data.action = 'sendTemplate';
            this._vm.$Xcontact.sendMessage(data);
        },
        getDefault({ commit }, data) {
            return new Promise((resolve, reject) => {
                let config = JSON.parse(localStorage.getItem("config"))
                commit('setLoading', true);
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004${data}`).then(res => {
                        if (res.data) {
                            commit('setLoading', false);
                            resolve(res.data);
                        }
                    }).catch(err => {
                        this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET DEFAULT ERROR] ` + err)
                        if (err.response) {
                            commit('setLoading', false);
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }

                        reject(err);
                    })
                ])
            })
        },
        getClassificacoes({ commit }, queue) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true);
                let config = JSON.parse(localStorage.getItem("config"))

                let filas = [];
                let param = {
                    max: -1,
                    page: 1
                }
                if (queue !== null) {
                    filas.push(queue);
                    param.filas = JSON.stringify(filas);
                }
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v2/classificacoes`, { params: param }).then(res => {
                        if (res.data.dados) {
                            commit('setLoading', false);
                            resolve(res.data.dados);
                        }
                    }).catch(err => {
                        if (err.response) {
                            commit('setLoading', false);
                            this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET CLASSIFICACOES ERROR] ` + err)
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }

                        reject(err);
                    })
                ])
            })
        },
        getSubClassificacoes({ commit }) {
            return new Promise((resolve, reject) => {
                commit('setLoading', true);
                let config = JSON.parse(localStorage.getItem("config"))
                let param = {
                    max: -1,
                    page: 1
                }
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v3/subclassificacao`, { params: param }).then(res => {
                        if (res.data.dados) {
                            commit('setLoading', false);
                            resolve(res.data.dados);
                        }
                    }).catch(err => {
                        this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET SUBCLASSIFICACOES ERROR] ` + err)
                        if (err.response) {
                            commit('setLoading', false);
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }

                        reject(err);
                    })
                ])
            })
        },
        setClassificacao({ commit }, dados) {
            try {
                commit(`setLoading`, true);
                let config = JSON.parse(localStorage.getItem("config"))
                Api.http.all([
                    Api.http.post(`https://${config.servidor}:8004/api/v2/chat/${dados.protocolo}/classificacao`, dados.data).then(() => {
                        commit(`setLoading`, false);
                    })
                ])
            } catch (error) {
                console.error(error);
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [SET CLASSIFICACAO ERROR] ` + error)
                commit(`setLoading`, false);
            }
        },
        setClassificacaoLigacao({ commit }, dados) {
            try {
                commit(`setLoading`, true);
                let config = JSON.parse(localStorage.getItem("config"))
                Api.http.all([
                    Api.http.post(`https://${config.servidor}:8004/api/v2/ligacao/classifica`, dados).then(() => {
                        commit(`setLoading`, false);
                    })
                ])
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [SET CLASSIFICACAO LIGACAO ERROR] ` + error)
                console.error(error);
                commit(`setLoading`, false);
            }
        },
        getClientes({ commit }) {
            try {
                let config = JSON.parse(localStorage.getItem("config"))
                commit('setLoading', true);
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v2/clientes?max=-1&page=1`).then(res => {
                        if (res.data) {
                            commit('setClientes', res.data);
                            commit('setLoading', false);
                        }
                    }).catch(err => {
                        this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET CLIENTES ERROR] ` + err)
                        if (err.response) {
                            commit('setLoading', false);
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }
                    })
                ])
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET CLIENTES ERROR] ` + error)
                console.log(error);
            }


        },
        setModalConfig({ commit }, data) {
            commit(`setModalConfig`, data);
        },
        setCliente({ commit }, data) {
            commit(`setCliente`, data);
        },
        setDrawer({ commit }, data) {
            commit(`setDrawer`, data);
        },
        getAllAtendimentos({ commit }, data) {
            try {
                let config = JSON.parse(localStorage.getItem("config"))
                var order = [];
                var obj = {
                    campo: 'dataIni',
                    ordem: 'DESC'
                };
                order.push(obj);
                let param = {
                    max: -1,
                    page: 1,
                    dataIni: data.dataIni,
                    FullMsg: false,
                    order: JSON.stringify(order)
                }
                if (data.dataFim) {
                    param.dataFim = data.dataFim;
                }
                commit('setLoading', true);
                Api.http.all([
                    Api.http.get(`https://${config.servidor}:8004/api/v2/chats`, { params: param }).then(res => {
                        if (res.data.dados) {
                            commit(`removeAtendimentos`);
                            let atendimentos = res.data.dados.map(d => {
                                //d.messages = d.queueChatMessages
                                //d.messages.map(m => m.status = 'seen');
                                //d.queueTypeID = d.queuetype;
                                d.pesquisa = true;
                                // if (d.messages && d.messages.length > 0) {
                                //     d.lastMsg = d.messages[d.messages.length - 1];
                                // }
                                return d;
                            })
                            commit('addAtendimentoSearch', atendimentos);
                            // for (let a of res.data.dados) {
                            //     a.messages = a.queueChatMessages;
                            //     a.queueTypeID = a.queuetype;
                            //     commit('addAtendimentoSearch', a);
                            // }
                            commit('setLoading', false);
                        }
                    }).catch(err => {
                        this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET ALL ATENDIMENTOS ERROR] ` + err)

                        if (err.response) {
                            commit('setLoading', false);
                            //commit('setError', { error: true, msg: err.response.data.message });
                        }


                    })
                ])
            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET ALL ATENDIMENTOS ERROR] ` + error)

                console.log(error);
            }


        },
        setError({ commit }, data) {
            commit(`setError`, data);
        },
        setEnviarMensagem({ commit }, data) {
            commit(`setEnviarMensagem`, data);
        },
        getHistoricoAtendimentosAgente({ commit }, data) {
            try {
                return new Promise(async (resolve, reject) => {
                    let config = JSON.parse(localStorage.getItem("config"))
                    var order = [];
                    var obj = {
                        campo: 'dataIni',
                        ordem: 'DESC'
                    };
                    let agentes = [];
                    agentes.push(data.agente);
                    order.push(obj);
                    let param = {
                        max: data.max ? data.max : -1,
                        page: 1,
                        FullMsg: false,
                        order: JSON.stringify(order),
                        agentes: JSON.stringify(agentes)
                    }
                    if (data.dataFim) {
                        param.dataFim = data.dataFim;
                    }
                    commit('setLoading', true);
                    Api.http.all([
                        Api.http.get(`https://${config.servidor}:8004/api/v2/chats`, { params: param }).then(res => {
                            if (res.data.dados) {
                                console.log(`aipim`, res.data.dados);
                                commit(`removeAtendimentosHistorico`);
                                let atendimentos = res.data.dados;
                                commit('addAtendimentoHistorico', atendimentos);
                                commit('setLoading', false);
                                console.log(`ADICIONOU`);
                                resolve(atendimentos);
                            }
                        }).catch(err => {
                            this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET HISTORICO AGENTE ATENDIMENTOS ERROR] ` + err)
                            if (err.response) {
                                commit('setLoading', false);
                                reject(err.response)
                                //commit('setError', { error: true, msg: err.response.data.message });
                            }


                        })
                    ])
                })

            } catch (error) {
                this._vm.$logger.saveToLog('xcontact.txt', `${new Date()} [GET HISTORICO AGENTE ATENDIMENTOS ERROR] ` + error)

                reject(error);
                console.log(error);
            }


        },

    },
    getters: {
        drawer: (state) => {
            return state.drawer
        },
        atendimento: state => {
            return state.atendimento;
        }
    },

}